export const regex = {
    REGEX_PHONE: /(\+34|0034|34)?[ -]*(6|7)[ -]*([0-9][ -]*){8}/,
    EQUALS_CONTAINER_PLATE: /[a-zA-Z]{4}[\d]{7}$/,
    NOT_EQUALS_CONTAINER_PLATE: /^(?![a-zA-Z]{4}[\d]{7}$)/,
    ONLY_NUMBERS_AND_LETTERS: /^[a-zA-Z0-9]*$/,
};

export const isValidPhoneNumber = (phoneNumber: string) => {
    return regex.REGEX_PHONE.test(phoneNumber);
};

export const isValidContainer = (containerId: string) => {
    return regex.EQUALS_CONTAINER_PLATE.test(containerId);
};
export const isValidTruck = (tuckId: string) => {
    return regex.NOT_EQUALS_CONTAINER_PLATE.test(tuckId);
};

export const notExpecialsCaracters = (text: string) => {
    return regex.ONLY_NUMBERS_AND_LETTERS.test(text);
};
